import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '@ui/icon/icon.component';

export interface Step {
  label: string;
  value: string | number;
}

@Component({
  selector: 'ui-stepper',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="steps-container">
      <div class="steps-wrapper">
        <div class="steps-line"></div>
        <div class="steps">
          <div *ngFor="let step of steps; let i = index" class="step-item">
            <div
              class="step-circle"
              [class.active]="currentStep === i"
              [class.completed]="currentStep > i"
            >
              <span class="step-number" *ngIf="currentStep <= i">{{ i + 1 }}</span>
              <ui-icon
                *ngIf="currentStep > i"
                name="check"
                class="icon-check"
              ></ui-icon>
            </div>
            <span class="step-label">{{ step.label }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .steps-container {
      @apply w-full py-4;
    }

    .steps-wrapper {
      @apply relative;
    }

    .steps-line {
      @apply absolute top-[24px] left-0 w-full h-[2px] bg-gray-200;
      z-index: 1;
    }

    .steps {
      @apply flex justify-between relative;
      z-index: 2;
    }

    .step-item {
      @apply flex flex-col items-center gap-2;
    }

    .step-circle {
      @apply flex items-center justify-center w-12 h-12 rounded-full bg-white border-2 border-gray-200 transition-all duration-200;

      &.active {
        @apply border-primary-500 bg-primary-500 text-white;
      }

      &.completed {
        @apply border-success-500 bg-success-500 text-white;
      }
    }

    .step-number {
      @apply text-lg font-medium;
    }

    .step-label {
      @apply text-sm font-medium text-gray-600;
    }

    .icon-check {
      @apply h-5 w-5 flex items-center justify-center;
      margin-top: -1px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {
  @Input({ required: true }) steps!: Step[];
  @Input({ required: true }) currentStep = 0;
}
